import React from "react";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateCustomer } from "../hooks";
import { CustomerForm } from "../components";

export const CreateCustomer: React.FC = () => {
  const { form, submit, loading } = useCreateCustomer({
    defaultValues: {},
    onCompleted: () => {
      toast.success("Le client a été créé avec succès");
    },
  });

  return (
    <>
      <Header
        title="Client"
        subtitle="Créer un nouveau client"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/customers`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouveau client" />
          <CustomerForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
